import classNames from "classnames";
import IntlMessages from "components/Message/IntlMessages";
import React from "react";

function Back({ className, goBack, message, labelClassName, disabled }) {
  return (
    <div
      className={classNames(
        "d-flex align-items-center",
        className
      )}
      onClick={disabled ? undefined : goBack}
    >
      <div className={classNames("button-chevron me-2 pointer", { "opacity-25 pe-none": disabled })}>
        <i className="feather-icon icon-arrow-left "></i>
      </div>
      <h5 className={classNames("pt-2 pointer mb-1", labelClassName)}>
        {message ? message : <IntlMessages id="global.back" />}
      </h5>
    </div>
  );
}

export default Back;
